import React from "react";
import { MdLanguage } from "react-icons/md";
import { useIdioma } from "stores/idiomaStore";

/**
 * Selector de idioma de la interfaz: español, inglés y chino.
 *
 * Las traducciones son archivos locales, no se piden a ningún servicio
 * externo: desde China los traductores de Google están bloqueados, y una
 * interfaz que depende de eso queda a medias justo donde más se necesita.
 *
 * La elección se guarda por navegador, así que cada persona ve el sistema en
 * su idioma sin afectar a los demás.
 */
export default function NavbarIdiomaSwitcher() {
  const { idioma, cambiarIdioma, idiomas, t } = useIdioma();

  return (
    <div
      className="flex items-center gap-1 rounded-2xl border border-slate-200/90 bg-white/90 px-1.5 py-1.5 shadow-sm dark:border-white/10 dark:bg-navy-900/80"
      role="group"
      aria-label={t("idioma.titulo")}
    >
      <MdLanguage
        className="mx-1 h-4 w-4 shrink-0 text-slate-400 dark:text-white/50"
        aria-hidden="true"
      />
      {idiomas.map((op) => {
        const activo = op.codigo === idioma;
        return (
          <button
            key={op.codigo}
            type="button"
            onClick={() => cambiarIdioma(op.codigo)}
            aria-pressed={activo}
            title={op.nombre}
            className={[
              "min-w-[34px] rounded-xl px-2 py-1 text-xs font-semibold transition-colors duration-200",
              activo
                ? "bg-brand-500 text-white shadow-sm dark:bg-brand-400"
                : "text-slate-500 hover:bg-slate-100 dark:text-white/60 dark:hover:bg-white/10",
            ].join(" ")}
          >
            {op.bandera}
          </button>
        );
      })}
    </div>
  );
}
